





































import Vue from 'vue';
import { Component, Emit } from 'vue-property-decorator';
import dxDateBox from 'devextreme/ui/date_box';
import { DxDateBox } from 'devextreme-vue/date-box';
import { DxPopup, DxToolbarItem } from 'devextreme-vue/popup';
import { DxRequiredRule, DxValidator } from 'devextreme-vue/validator';
import { InvoiceLookupLineItemDto } from '@/models/invoice/InvoiceLookupLineItemDto';

@Component({
  components: {
    DxDateBox,
    DxPopup,
    DxRequiredRule,
    DxToolbarItem,
    DxValidator
  }
})
export default class EditInvoiceDate extends Vue {
  private readonly title: string = 'Change Invoice Date';
  private dateBox: dxDateBox | undefined;
  private originalValue: Date | null = null;
  private showDialog: boolean = false;

  public dialogResult: boolean | null = null;
  public lineItem: InvoiceLookupLineItemDto | null = null;
  public value: Date | null = null;
  public valueChanged: boolean = false;

  private get okButtonOptions() {
    return {
      text: 'OK',
      type: 'default',
      stylingMode: 'contained',
      onClick: this.ok
    };
  }

  private get cancelButtonOptions() {
    return {
      text: 'Cancel',
      type: 'normal',
      stylingMode: 'contained',
      onClick: this.cancel
    };
  }

  public show() {
    this.showDialog = true;
  }

  private ok() {
    if (this.isValid()) {
      this.close(true);
    }
  }

  private isValid() {
    if (this.dateBox == null) {
      return true;
    }

    return this.dateBox.option('isValid') as boolean;
  }

  private cancel() {
    this.close(false);
  }

  private close(dialogResult: boolean) {
    this.dialogResult = dialogResult;
    this.showDialog = false;
  }

  private onShowing() {
    this.dialogResult = null;
    this.originalValue = this.value;
  }

  @Emit('hiding')
  private onHiding() {
    this.valueChanged = this.value !== this.originalValue;
    return this.dialogResult;
  }

  private onDateBoxInitialized(e: any) {
    this.dateBox = e.component;
  }
}
